import { render } from "./recommend.vue?vue&type=template&id=5472b3cc&ts=true"
import script from "./recommend.vue?vue&type=script&lang=ts"
export * from "./recommend.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__